import { HttpService } from '@Services/index';
import { useMutation } from '@tanstack/react-query';
import { useBoundStore } from '@Store/useBoundStore';

interface StartAuthorizedUserOnboardingRequest {
  phoneNumber: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
}

export const startAuthorizedUserOnboarding = async (data: StartAuthorizedUserOnboardingRequest) => {
  const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;

  const url = `v3/onboarding/user/${customerId}/authorized/user/${authorizedUserId}/start`;

  try {
    await HttpService.post(url, data);
  } catch (error) {
    throw error;
  }
};

export const useStartAuthorizedUserOnboarding = () =>
  useMutation({
    mutationFn: startAuthorizedUserOnboarding,
  });
